import { closeModal, render } from '~/legacy/runtime'
import { legacyState } from '~/legacy/screens'
import type { Row } from '~/composables/useDb'

/** `submitBulkReduction` de la maquette : applique une réduction aux étudiants cochés dans « Inscriptions en attente ». */
export async function submitBulkReduction(): Promise<void> {
  const select = document.getElementById('bulk-reduction-id') as HTMLSelectElement | null
  const reductionId = select?.value ?? ''
  const reduction = findById('reductions', reductionId)
  if (!reduction) {
    showToast('Choisis une réduction.')
    return
  }
  const selection = legacyState.caisseSelection as Set<string>
  const db = useDb()
  let count = 0
  try {
    for (const inscriptionId of selection) {
      const inscription = findById('inscriptions', inscriptionId)
      if (!inscription) continue
      const classe = findById('classes', inscription.classeId)
      const tarif = classe ? tarifForClasse(classe.id as string) : null
      const base = tarif ? Number(tarif.montant) : 0
      const montantCalcule = reduction.type === 'POURCENTAGE' ? Math.round(base * Number(reduction.valeur) / 100) : Number(reduction.valeur)
      const saved = await $fetch<Row>('/api/reductionsAppliquees', {
        method: 'POST',
        body: { inscriptionId, reductionId: reduction.id, montantCalcule, dateApplication: new Date().toISOString().slice(0, 10), justificatif: 'Application groupée depuis la Caisse' },
      })
      db.value = { ...db.value, reductionsAppliquees: [...(db.value.reductionsAppliquees ?? []), saved] }
      await recomputeEcheancierRemise(inscriptionId)
      count++
    }
  }
  catch (e) {
    console.error('[Registre] submitBulkReduction:', e)
    showToast('Opération impossible.')
    return
  }
  closeModal()
  legacyState.caisseSelection = new Set()
  showToast(`Réduction « ${reduction.libelle} » appliquée à ${count} étudiant${count > 1 ? 's' : ''}.`)
  render()
}

/** `wizardTarifForClasse` de la maquette. */
function tarifForClasse(classeId: string): Row | null {
  const classe = findById('classes', classeId)
  if (!classe) return null
  return (useDb().value.tarifications ?? []).find(t => isTarifKind(t, 'SCOLARITE') && t.niveauId === classe.niveauId && t.ecoleId === useCurrentEcoleId().value)
    || useDb().value.tarifications?.[0] || null
}
